import { render, staticRenderFns } from "./PTranslatableCkeditor.vue?vue&type=template&id=7765dd1b&"
import script from "./PTranslatableCkeditor.vue?vue&type=script&lang=js&"
export * from "./PTranslatableCkeditor.vue?vue&type=script&lang=js&"
import style0 from "./PTranslatableCkeditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports